import { useState } from 'react'
import { TMedEventUI } from 'src/types/med-event'
import { CurecallMedEventButton } from '@honestica/curecall-ui'
import FollowupMedEventForm from './med-event-form.component'
import { useTranslation } from 'react-i18next'
import { useFollowupFormContext } from '../generic-followup-form.component'
import { getErrorMessageIfMinIsNotReached } from '../generic-followup-form.helper'
import { useCurrentProject } from 'src/providers/current-project.provider'

interface Props {
  recommendedMedEvent: TMedEventUI
}
const RecommendedMedEvent = ({ recommendedMedEvent }: Props) => {
  const { t } = useTranslation()
  const { getMedEventLabelById } = useCurrentProject()
  const [isEdited, setIsEdited] = useState<boolean>(false)

  const { selectNewMedEventToComplete, validationErrors } = useFollowupFormContext()

  if (isEdited) {
    return (
      <div key={`recommanded-${recommendedMedEvent.MedEvent.id}-form`}>
        <FollowupMedEventForm
          onCloseCallback={() => {
            setIsEdited(false)
          }}
        />
      </div>
    )
  }

  const errorMessage = getErrorMessageIfMinIsNotReached(
    t,
    recommendedMedEvent.MedEvent.type,
    validationErrors,
  )

  return (
    <div
      key={`recommanded-${recommendedMedEvent.MedEvent.id}-button`}
      className={errorMessage ? 'c-mb-4' : ''}
    >
      <CurecallMedEventButton
        name={getMedEventLabelById(recommendedMedEvent.MedEvent.id)}
        onClick={() => {
          const isSelected = selectNewMedEventToComplete?.(recommendedMedEvent)
          isSelected && setIsEdited(true)
        }}
        errorMessage={errorMessage}
      />
    </div>
  )
}

export default RecommendedMedEvent
